export default {
  methods: {
    formatBytes(bytes, decimals = 2) {
      if (bytes === null || bytes === undefined || isNaN(bytes) || bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    isImageFile(file) {
      return file && typeof file.type === 'string' && file.type.startsWith('image/');
    },
    createFilePreviewUrl(file) {
      return URL.createObjectURL(file);
    },
    revokeFilePreviewUrl(url) {
      URL.revokeObjectURL(url);
    },
  }
};
